import React from 'react';

export default function ConnectButton(props) {
    return (
        <button className="balance d-flex" onClick={() => props.onClick()}>
            <div className="text-flame"><i style={{marginRight: '8px'}} className="fa fa-wallet"></i><strong>Connect Wallet</strong></div>
        </button>
    )
}